export const shouldLoad = () => document.querySelector('[data-controller="timeline-section"]') !== undefined;